import { render } from "./LegalWarningView.vue?vue&type=template&id=5dec9486"
import script from "./LegalWarningView.vue?vue&type=script&lang=js"
export * from "./LegalWarningView.vue?vue&type=script&lang=js"

import "./LegalWarningView.vue?vue&type=style&index=0&id=5dec9486&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__